// Centralized configuration for DSA Landing Page

const WHATSAPP_NUMBER = "51947235336";
const WHATSAPP_MESSAGE =
  "Hola, quiero recibir información sobre la ruta de Ecommerce de DSA.";

export const config = {
  whatsapp: {
    number: WHATSAPP_NUMBER,
    message: WHATSAPP_MESSAGE,
    url: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
  },
  brand: {
    name: "Digital Strategy Agency",
    shortName: "DSA",
    tagline: "Economía Digital",
  },
  contact: {
    email: "contacto@dsaeconomiadigital.com",
  },
  api: {
    baseUrl: `${process.env.REACT_APP_BACKEND_URL || ""}/api`,
  },
};
